export default "__VITE_ASSET__CRxgOh7e__"